/* 홈의 표시 문구와 공용 상대 시각. 작품 선정·순서는 어드민 홈 구성(bootstrap?catalog=home)이 소유한다. */

/** 유형에 따라 제목·부제의 낱말을 바꾼다 (레퍼런스 WORD) */
export function homeWords(story: boolean) {
  return {
    unit: story ? '이야기' : '캐릭터',
    fresh: story ? '새로 열린 이야기' : '새로 온 캐릭터',
    allTitle: story ? '전체 이야기' : '전체 캐릭터',
  }
}

/** 마지막 대화 시각 — "방금 전 · 12분 전 · 3시간 전 · 2일 전" */
export function ago(iso: string, now = Date.now()) {
  const min = Math.floor((now - new Date(iso).getTime()) / 60000)
  if (!Number.isFinite(min) || min < 1) return '방금 전'
  if (min < 60) return `${min}분 전`
  if (min < 1440) return `${Math.floor(min / 60)}시간 전`
  return `${Math.floor(min / 1440)}일 전`
}
